import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import { HCPTheme } from 'housecall-ui/dist/Theme/Theme';

const useStyles = makeStyles((theme: HCPTheme) => ({
  planHeader: {
    fontSize: theme.typography.subtitle1.fontSize,
    fontWeight: theme.typography.subtitle1.fontWeight,
    color: theme.palette.black.primary,
  },
  planHeaderExtraInfo: {
    marginLeft: theme.spacing(1) / 2,
  },
}));

const PlanHeaderText = (props: { planName: string; extraInfo: string }) => {
  const { planHeader, planHeaderExtraInfo } = useStyles();
  const { planName, extraInfo } = props;

  const ExtraInfo = (
    <Typography variant="caption" className={planHeaderExtraInfo} data-testid="plan-header-extra-info">
      {`(${extraInfo})`}
    </Typography>
  );

  return (
    <Grid container alignItems="center" data-testid="plan-header">
      <Typography aria-label="plan name" className={planHeader} data-testid="plan-name">
        {planName.toUpperCase()}
      </Typography>
      {extraInfo ? ExtraInfo : null}
    </Grid>
  );
};

export default PlanHeaderText;
